<section id="about-hero" class="w-100 text-light" 
         style="margin-top: 66px; background: linear-gradient(45deg, #1A2042, #173580);">
  <div class="container py-5">
    <div class="">
      
      <!-- Left: About intro -->
      <div class="text-center mb-4 mb-lg-0">
        <h1 class="fw-bold mb-4">Looking for a job in the software industry?</h1>
        <p class="lead mb-4 fw-medium">
          At ChalkBasket, we prepare you with the right skills, tools, and guidance to secure a job in the software industry and grow into a successful tech career  
        </p>
        <button class="btn btn-outline-light px-4 py-2 rounded-2 shadow-sm mt-3" (click)="navigateAndScroll('/home')">
          Sign up for free
        </button>
      </div>
    </div>
  </div>
</section>

<section>
 <div class="mt-5 container-md mb-5 legal-content">
   <h3 class="text-center">Disclaimer</h3>
   <p class="text-center" style="color: gray;">Last updated: November 6, 2025</p>
   <hr>

   <p>The information provided on <strong>ChalkBasket.com</strong> is for <strong>educational and informational purposes only</strong>. While we strive to ensure accuracy and relevance, we make no representations or warranties of any kind, express or implied, about the completeness, reliability, suitability, or availability of the information, courses, or resources provided.</p>

   <h4>No Guarantees</h4>
   <p>Participation in our training, mentorship, or learning programs does not guarantee employment or job placement. Success depends on individual effort, dedication, skill development, and external factors beyond our control.</p>

   <h4>Professional Advice</h4>
   <p>The content on this website should not be considered as professional, legal, or career advice. Students are encouraged to seek independent guidance where necessary.</p>

   <h4>External Links</h4>
   <p>Our website may contain links to external websites or resources. We are not responsible for the accuracy, reliability, or content of any third-party sites. Accessing them is at your own risk.</p>

   <h4>Limitation of Liability</h4>
   <p>Under no circumstances shall <strong>ChalkBasket.com</strong>, its team, or affiliates be held liable for any direct, indirect, or consequential loss or damage arising from the use of our website, courses, or services.</p>

   <h4>Consent</h4>
   <p>By using our website and services, you hereby consent to our disclaimer and agree to its terms.</p>

   <h4>Updates</h4>
   <p>This disclaimer may be updated or modified without prior notice. Please check this page periodically for the latest version.</p>
 </div>
</section>
